import SwiperCore, { Navigation, Autoplay, EffectFade } from 'swiper/core';
SwiperCore.use([Navigation, Autoplay, EffectFade]);
import Swiper from 'swiper';

(function($) {
  $(function() {
    $('.image-slider__swiper').each(function() {
      var $slider = $(this);
      var autoplay = $slider.data('autoplay') ? true : false;

      var options = {
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        speed: 700
      };

      if(autoplay) {
        options.autoplay = {
          delay: 2000
        }
      }

      var swiper = new Swiper($slider.get(0), options);
    });
  });
})(jQuery);
